import { render, staticRenderFns } from "./TheLegal.vue?vue&type=template&id=3c06b0e0&scoped=true"
import script from "./TheLegal.vue?vue&type=script&lang=js"
export * from "./TheLegal.vue?vue&type=script&lang=js"
import style0 from "./TheLegal.vue?vue&type=style&index=0&id=3c06b0e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06b0e0",
  null
  
)

export default component.exports